var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('homeHead'),_vm._v(" "),_c('homeNav'),_vm._v(" "),_c('breadcrumb',{attrs:{"positionData":_vm.positionData}}),_vm._v(" "),_c('div',{staticClass:"dynamics-box clearfix"},[_c('projectMenu',{attrs:{"positionData":_vm.positionData}}),_vm._v(" "),_c('rightContent')],1),_vm._v(" "),_c('homeFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b3f2b60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamics/index.vue
// module id = eq6e
// module chunks = 1